import { createAction } from 'redux-actions';
import { ProfileInfo } from '../api/types';

export interface FetchIssueReportsPayload {
    includeArchived?: boolean;
}

export interface FetchAssetsForIssueReportsPayload {}

export interface FetchIssueReportPayload {
    id: string;
}

export interface UpdateIssueReportStatusPayload {
    id: string;
    status: string;
}

export interface CreateIssueReportPayload {
    message: string;
    assets: {
        depotId: string;
        door: number;
        assetId?: string;
    }[];
    issueType: string;
    service: string;
    orderId?: string;
    bookingNumber?: string;
    profileInfo?: ProfileInfo;
    /** Location of the reported problem. Kept on the report itself so a
     *  report filed without a locker still has one. */
    locationId?: string;
}

const IssueReportsCommands = {
    fetchIssueReports:
        createAction<FetchIssueReportsPayload>('FETCH_ISSUEREPORTS'),
    fetchAssetsForIssueReports:
        createAction<FetchAssetsForIssueReportsPayload>('FETCH_ASSETS_FOR_ISSUEREPORTS'),
    fetchIssueReport:
        createAction<FetchIssueReportPayload>('FETCH_ISSUEREPORT'),
    updateIssueReportStatus: createAction<UpdateIssueReportStatusPayload>(
        'UPDATE_ISSUEREPORT_STATUS',
    ),
    createIssueReport: createAction<CreateIssueReportPayload>(
        'CREATE_ISSUEREPORTS',
    ),
};

export default IssueReportsCommands;
